import { NotFoundUI } from '../../components/common/error/not-found';

export const dynamic = 'force-static';

export default function NotFound() {
  return <NotFoundUI />;
}
